module.exports = __webpack_public_path__ + "6a11319f8b815363b25df7ce2472a377.MP3";